import { faCubes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

function Projects() {
  return (
    <div className='mt-2'>
        <div className='jumbotron text-center bg-light border'>
            <FontAwesomeIcon icon={faCubes} fontSize={128} className='mb-5 text-danger'/>
            <h2>Software Projects</h2>
            <p>Some of the software projects we have developed on for our clients.</p>
        </div>
        <div className='container'></div>
    </div>
  )
}

export default Projects